// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1GEEQ","addWidgetButton":"Header_addWidgetButton__3jBO_","dashboardTabs":"Header_dashboardTabs__2T0fp","active":"Header_active__iGJUi"};